(function () {
    angular
        .module('smartertoolsApp')
        .controller('passwordResetController', ['$scope', '$http', '$window', 'notificationFactory', passwordResetController]);

    function passwordResetController($scope, $http, $window, notify) {
        const vm = this;
        vm.mode = 'form';
        vm.resetGuid = null;

        // Functions
        vm.doChange = doChange;
        activate();

        // -----------------------------------------------

        function activate() {
            vm.resetGuid = sessionStorage.getItem('passwordreset.resetGuid');
            if (!vm.resetGuid) {
                $window.location.replace('/');
            }
        }

        function doChange() {
            if (vm.passwordform.$invalid || !vm.resetGuid)
                return;
            $http.post(apiRootUrl + 'v1/account/reset-password', JSON.stringify({
                ResetGuid: vm.resetGuid,
                Password: vm.Password
            }))
                .then(function () {
                    vm.mode = 'done';
                    sessionStorage.removeItem('passwordreset.resetGuid');
                }, function (err) {
                    notify.error(err.statusText || err.data || 'There was a problem changing your password.  Please contact us directly for assistance.');
                });
        }
    }
})();